const baseURL = "https://skewb.ai:8000";
// const baseURL = "http://15.207.123.147:8000/api/"
export default baseURL;
